import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Spinner from '@components/Common/Spinner';

import styles from './style.module.css';

const PRIMARY = 'PRIMARY';
const SECONDARY = 'SECONDARY';

const themeClassNames = {
  [PRIMARY]: styles.primary,
  [SECONDARY]: styles.secondary,
};

const Button = ({
  theme = PRIMARY,
  type = '',
  disabled = false,
  color = '',
  loading = false,
  children,
  className = '',
  dataTestId = '',
  onClick = () => { }
}) => {
  const themeClassName = themeClassNames[theme] || themeClassNames.PRIMARY;
  const buttonClassName = classNames(styles.button, themeClassName, className, {
    [styles.loading]: loading,
    [styles.disabled]: disabled || loading,
  });

  const buttonStyle = color ? { '--button-color': color } : {};

  const content = (
    <>
      <span className={classNames({ [styles.hidden]: loading })}>{children}</span>
      {loading && <Spinner type={theme} />}
    </>
  );

  return (
    <button
      className={buttonClassName}
      data-testid={dataTestId}
      style={buttonStyle}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {content}
    </button>
  );
};

Button.propTypes = {
  color: PropTypes.string,
  theme: PropTypes.oneOf([PRIMARY, SECONDARY]),
  type: PropTypes.string,
  action: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.bool]),
  childen: PropTypes.node,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  dataTestId: PropTypes.string
};

Button.themes = {
  PRIMARY,
  SECONDARY,
};

export default Button;
